import { render, staticRenderFns } from "./SideBarMonthlyCost.vue?vue&type=template&id=50956b1d"
import script from "./SideBarMonthlyCost.vue?vue&type=script&lang=js"
export * from "./SideBarMonthlyCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports